import React, { Component } from "react";
import { EditorState, convertToRaw, ContentState, Modifier } from "draft-js";
import "../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { Editor } from "react-draft-wysiwyg";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";

import UserInfoStore from "../../stores/userInfoStores";

import "./style.scss";

// import ImgUpload from "./imageUpload";
import FileUpload from "./fileUpload";

import {
    fileObjToS3,
    handlePasteLink,
    insertImage,
    handlePastedText,
    validateUrl,
    renderCustomContent
} from "./common";

class EditorComponent extends Component {
    constructor(props) {
        super(props);
        // const html = `<a href="https://happay.atlassian.net/browse/HEPS-4675" target="_blank">https://happay.atlassian.net/browse/HEPS-4675 </a>`;

        const html = props.value;
        this.state = {
            editorState: this.htmlToDraftBlocks(html)
        };
    }

    componentDidMount() {
        const { editorState } = this.state;
        this.setState(
            {
                editorState: EditorState.moveFocusToEnd(editorState)
            },
            () => {
                this.props.getCommentedData(
                    editorState
                        .getCurrentContent()
                        .getPlainText()
                        .trim()
                );
            }
        );
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.value === "") {
            const html = nextProps.value;
            this.setState({
                editorState: this.htmlToDraftBlocks(html)
            });
        }
    }

    componentDidUpdate() {
        const dataTextTrue = document.querySelectorAll("[data-text]");
        const dataBlockTrue = document.querySelectorAll("[data-block]");
        let whichHeading = null;
        let obj = {
            H1: 24,
            H2: 20,
            H3: 16,
            H4: 14
        };
        if (dataTextTrue.length) {
            // modifing span font size
            for (const item of dataTextTrue) {
                whichHeading = item?.closest("h1, h2, h3, h4, h5, h6")?.nodeName;
                const parentItem = item.parentElement;
                let fontSize = parentItem.style.fontSize || 12;
                fontSize = whichHeading ? obj[whichHeading] : fontSize;
                const fontWeight = parentItem.style.fontWeight;
                item.style.setProperty("font-size", fontSize, "important");
                item.style.setProperty("font-weight", fontWeight);
            }

            // modifing span font size if <h> tag change
            if (dataBlockTrue.length) {
                if (whichHeading && whichHeading.includes("H")) {
                    for (const item of dataTextTrue) {
                        whichHeading = item?.closest("h1, h2, h3, h4, h5, h6")?.nodeName;
                        const fontSize = obj[whichHeading] || 12;
                        item.style.setProperty("font-size", `${fontSize}px`, "important");
                    }
                }
            }
        }
    }

    htmlToDraftBlocks = html => {
        const blocksFromHtml = htmlToDraft(html);
        const { contentBlocks, entityMap } = blocksFromHtml;
        const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
        const editorState = EditorState.createWithContent(contentState);
        return EditorState.moveFocusToEnd(editorState);
    };

    /*  polyfill of splice for string
        if(!String.prototype.splice) {
            String.prototype.splice = function(start, delCount, newSubStr) {
                return this.slice(0, start) + newSubStr + this.slice(start + Math.abs(delCount));
            };
        }
    */
    // modify the above polyfill
    spliceForString = (str, start, delCount, newSubStr) => {
        return str.slice(0, start) + newSubStr + str.slice(start + Math.abs(delCount));
    };

    editSpanFontSize = editorHtmlContent => {
        while (editorHtmlContent.indexOf("px;") >= 0) {
            const index = editorHtmlContent.indexOf("px;");
            editorHtmlContent = this.spliceForString(
                editorHtmlContent,
                index + 2,
                0,
                " !important"
            );
        }
        return editorHtmlContent;
    };

    onEditorStateChange = editorState => {
        const { returnEditorContent = () => {} } = this.props;
        editorState = handlePasteLink(editorState);
        this.setState(
            {
                editorState
            },
            () => {
                let editorHtmlContent = draftToHtml(convertToRaw(editorState.getCurrentContent()));
                editorHtmlContent = this.editSpanFontSize(editorHtmlContent);
                editorHtmlContent = `${editorHtmlContent}`;
                editorHtmlContent = editorHtmlContent.replace(
                    /text-align:none;/g,
                    "text-align:center;"
                );
                returnEditorContent(
                    editorHtmlContent,
                    editorState
                        .getCurrentContent()
                        .getPlainText()
                        .trim()
                );
            }
        );
    };

    handleUploadReturnProps = data => {
        this.setState({
            editorState: EditorState.moveFocusToEnd(data)
        });
    };

    handlePastedText = (text, html, editorState, onChange) => {
        handlePastedText(text, html, editorState, onChange);
    };

    handlePastedFiles = data => {
        // const url = await fileObjToBase64(data[0]);
        fileObjToS3(data);
    };

    handleDroppedFiles = (selectionState, file) => {
        if (file && file.length) {
            fileObjToS3(file);
        }
    };

    verifyAddedLink = linkData => {
        if (validateUrl(linkData?.target)) {
            return linkData;
        }

        UserInfoStore.showToast("This is not a valid link!");
        return {
            title: "",
            target: "",
            targetOption: ""
        };
    };

    render() {
        const { editorState } = this.state;
        return (
            <div>
                <Editor
                    placeholder="Begin typing..."
                    editorState={editorState}
                    wrapperClassName="richTextParentBlock"
                    editorClassName="richTextEditorBlock"
                    onEditorStateChange={this.onEditorStateChange}
                    toolbar={{
                        options: [
                            "inline",
                            "blockType",
                            "fontSize",
                            "list",
                            "textAlign",
                            "colorPicker",
                            "link",
                            "emoji",
                            "remove",
                            "history"
                        ],
                        inline: {
                            options: [
                                "bold",
                                "italic",
                                "underline",
                                "strikethrough",
                                "superscript",
                                "subscript"
                            ]
                        },
                        blockType: {
                            options: ["Normal", "Blockquote", "Code"]
                        },
                        link: {
                            defaultTargetOption: "_blank",
                            linkCallback: linkData => this.verifyAddedLink(linkData)
                        }
                    }}
                    // toolbar={{
                    //     image: { component: ImgUpload },
                    // }}
                    toolbarCustomButtons={[
                        <FileUpload
                            fileUploadReturnProps={data => this.handleUploadReturnProps(data)}
                        />
                    ]}
                    handlePastedText={this.handlePastedText}
                    handlePastedFiles={this.handlePastedFiles}
                    handleDroppedFiles={this.handleDroppedFiles}
                    handleDrop={this.handleDroppedFiles}
                />
            </div>
        );
    }
}

export default EditorComponent;
